import {
  Box,
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  Modal,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Fpm.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setBnkRanks,
  setCoopRanks,
  setDigiRanks,
  setIMRanks,
  setLFRanks,
  setMicroRanks,
  setMARanks,
} from "../features/fpmSlice/FmpSlice";
import { CloseRounded } from "@mui/icons-material";
import * as FirestoreService from "../utils/firestoreQuery";
import Logo from "../images/logo_quick-learning-tool.png";
import Swal from "sweetalert2";

function FpmPage4() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let TRows = [];
  let TRankBnk = [];
  let TRankCoop = [];
  let TRankMicro = [];
  let TRankLF = [];
  let TRankIM = [];
  let TRankMA = [];
  let TRankDigi = [];
  let rank = [];
  const [myArray, setMyArray] = useState([]);
  const [myArray2, setMyArray2] = useState([]);
  const [anti, setAnti] = useState(0);
  const [num, setNum] = useState(0);
  const [tableGuide, setTableGuide] = useState();
  const [openSample, setOpenSample] = useState(false);
  const handleOpenSample = () => setOpenSample(true);
  const handleCloseSample = () => setOpenSample(false);

  const {
    sCheck1,
    sCheck2,
    sCheck3,
    sCheck4,
    sCheck5,
    sCheck6,
    sCheck7,
    sCheck8,
    sCheck9,
    sCheck9Text,
    fspType,
    q3Check1,
    q3Check2,
    q3Check3,
    q3Check4,
    q3Check5,
    q3Check6,
    q3Check7,
    bnkState,
    coopState,
    microState,
    lfState,
    imState,
    maState,
    digiState,
    lCheck1,
    lCheck2,
    lCheck3,
    lCheck4,
    lCheck5,
    lCheck6,
    lCheck7,
    lCheck8,
    lCheck9,
    lCheck10,
    lCheck11,
    iCheck1,
    iCheck2,
    iCheck3,
    iCheck4,
    iCheck5,
    iCheck6,
    iCheck7,
    iCheck8,
    iCheck9,
    iCheck10,
    iCheck11,
  } = useSelector((state) => state.fpm);

  const handleContinue = () => {
    console.log("bank:" + TRankBnk);
    console.log("coop:" + TRankCoop);

    if (q3Check1 === true) {
      if (TRankBnk.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Ranking",
          text: "Please complete all required rankings to proceed",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("1");
        return;
      }
    }

    if (q3Check2 === true) {
      if (TRankCoop.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Ranking",
          text: "Please complete all required rankings to proceed",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("2");
        return;
      }
    }
    if (q3Check3 === true) {
      if (TRankMicro.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Ranking",
          text: "Please complete all required rankings to proceed",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("3");
        return;
      }
    }
    if (q3Check4 === true) {
      if (TRankLF.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Ranking",
          text: "Please complete all required rankings to proceed",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("4");
        return;
      }
    }
    if (q3Check5 === true) {
      if (TRankIM.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Ranking",
          text: "Please complete all required rankings to proceed",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("5");
        return;
      }
    }
    if (q3Check6 === true) {
      if (TRankDigi.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Ranking",
          text: "Please complete all required rankings to proceed",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("6");
        return;
      }
    }
    if (q3Check7 === true) {
      if (TRankMA.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Incomplete Ranking",
          text: "Please complete all required rankings to proceed",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("7");
        return;
      }
    }

    const arrays = [
      TRankBnk,
      TRankCoop,
      TRankDigi,
      TRankIM,
      TRankLF,
      TRankMicro,
      TRankMA,
    ];

    const hasEmptyString = arrays.some((arr) =>
      arr.some((item) => item === "")
    );

    if (hasEmptyString) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Ranking",
        text: "Please complete all required rankings to proceed",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      console.log("Blank");
      return;
    }

    dispatch(setBnkRanks(TRankBnk));
    dispatch(setCoopRanks(TRankCoop));
    dispatch(setDigiRanks(TRankDigi));
    dispatch(setIMRanks(TRankIM));
    dispatch(setMARanks(TRankMA));
    dispatch(setLFRanks(TRankLF));
    dispatch(setMicroRanks(TRankMicro));
    navigate("/page5/En");
  };

  const handleBack = () => {
    navigate("/page3/En");
  };

  const savingsTableData = () => {
    if (sCheck1 === true) {
      TRows = [...TRows, "Initial deposit to open an account (PHP)"];
    }
    if (sCheck2 === true) {
      TRows = [...TRows, "Requirements to open an account"];
    }
    if (sCheck3 === true) {
      TRows = [...TRows, "Maintaining balance (PHP)"];
    }
    if (sCheck4 === true) {
      TRows = [...TRows, "Interest on deposit (%, annually)"];
    }
    if (sCheck5 === true) {
      TRows = [...TRows, "Amount of deposit to earn interest (PHP)"];
    }
    if (sCheck6 === true) {
      TRows = [...TRows, "Withdrawal Process"];
    }
    if (sCheck7 === true) {
      TRows = [...TRows, "Deposit insurance"];
    }
    if (sCheck8 === true) {
      TRows = [...TRows, "Fees and charges (PHP)"];
    }
    if (sCheck9 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    setMyArray(TRows);
    setAnti(1);
  };

  const loansTableData = () => {
    if (lCheck1 === true) {
      TRows = [...TRows, "Loan amount (PHP)"];
    }
    if (lCheck2 === true) {
      TRows = [...TRows, "Requirements to get a loan"];
    }
    if (lCheck3 === true) {
      TRows = [
        ...TRows,
        "Bundled financial product (e.g., savings, insurance)",
      ];
    }
    if (lCheck4 === true) {
      TRows = [
        ...TRows,
        "Repayment mode and regular principal amount (e.g. PHP 1,000 per month)",
      ];
    }
    if (lCheck5 === true) {
      TRows = [...TRows, "Interest rate (%, monthly)"];
    }
    if (lCheck6 === true) {
      TRows = [...TRows, "Effective Interest Rate (EIR, %, annually)"];
    }
    if (lCheck7 === true) {
      TRows = [...TRows, "Other fees and charges (PHP)"];
    }
    if (lCheck8 === true) {
      TRows = [
        ...TRows,
        "Bundled non-financial products at no cost to clients (e.g. financial education, skills training, etc.)",
      ];
    }
    if (lCheck9 === true) {
      TRows = [...TRows, "Collateral"];
    }
    if (lCheck10 === true) {
      TRows = [...TRows, "Repayment term"];
    }
    if (lCheck11 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    setMyArray(TRows);
    setAnti(1);
  };

  const insuranceTableData = () => {
    if (iCheck1 === true) {
      TRows = [...TRows, "Total premium to be paid (PHP)"];
    }
    if (iCheck2 === true) {
      TRows = [...TRows, "Delivery channel- to claim"];
    }
    if (iCheck3 === true) {
      TRows = [...TRows, "Payment term"];
    }
    if (iCheck4 === true) {
      TRows = [
        ...TRows,
        "Mode of payment and amount of premium on installment",
      ];
    }
    if (iCheck5 === true) {
      TRows = [...TRows, "Requirement to buy a policy"];
    }
    if (iCheck6 === true) {
      TRows = [...TRows, "Delivery channel- to buy an insurance policy"];
    }
    if (iCheck7 === true) {
      TRows = [...TRows, "Delivery channel- to pay the regular premium"];
    }
    if (iCheck8 === true) {
      TRows = [...TRows, "Amount of coverage"];
    }
    if (iCheck9 === true) {
      TRows = [...TRows, "Requirements when filing claim"];
    }
    if (iCheck10 === true) {
      TRows = [...TRows, "Average number of days to settle claim"];
    }
    if (iCheck11 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    setMyArray(TRows);
    setAnti(1);
  };

  const setRank = () => {
    if (num === 1) {
      rank = [...rank, 1];
    }
    if (num === 2) {
      rank = [...rank, 1, 2];
    }
    if (num === 3) {
      rank = [...rank, 1, 2, 3];
    }
    if (num === 4) {
      rank = [...rank, 1, 2, 3, 4];
    }
    if (num === 5) {
      rank = [...rank, 1, 2, 3, 4, 5];
    }
    if (num === 6) {
      rank = [...rank, 1, 2, 3, 4, 5, 6];
    }
    if (num === 7) {
      rank = [...rank, 1, 2, 3, 4, 5, 6, 7];
    }

    console.log("num: " + num);
    setMyArray2(rank);
    setAnti(1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const arr = [
      q3Check1,
      q3Check2,
      q3Check3,
      q3Check4,
      q3Check5,
      q3Check6,
      q3Check7,
    ];

    const count = arr.filter(Boolean).length;
    setNum(count);

    if (fspType === "Savings") {
      savingsTableData();
    }
    if (fspType === "Loans") {
      loansTableData();
    }
    if (fspType === "Insurance") {
      insuranceTableData();
    }

    setRank();

    FirestoreService.getFPMAssests().onSnapshot((doc) => {
      setTableGuide(doc.data().fpmAssets.page4Popup);
    });
  }, [anti]);

  const handleSelectBnk = (e, index) => {
    TRankBnk[index] = e.target.value;
  };

  const handleSelectCoop = (e, index) => {
    TRankCoop[index] = e.target.value;
  };

  const handleSelectMicro = (e, index) => {
    TRankMicro[index] = e.target.value;
  };

  const handleSelectLF = (e, index) => {
    TRankLF[index] = e.target.value;
  };

  const handleSelectIM = (e, index) => {
    TRankIM[index] = e.target.value;
  };

  const handleSelectMA = (e, index) => {
    TRankMA[index] = e.target.value;
  };

  const handleSelectDigi = (e, index) => {
    TRankDigi[index] = e.target.value;
  };

  return (
    <Box className="Main__Card__FPM">
      <Grid container>
        <Grid Item xs={12} md={3} className="left-card">
          <Box className="new-logo-container">
            <img src={Logo} alt="logo" className="new-logo-img" />
          </Box>
          <Box sx={{ marginBottom: "1rem" }}>
            <Button className="fpm--button" onClick={() => navigate("/Fil")}>
              To Filipino Ver.
            </Button>
          </Box>
          <Box className="instruction-card">
            <p className="instruction-title">Activity Instructions</p>
            <p className="instruction-text">
              Choose a Suitable Financial Product and Service Provider.
            </p>
            <p className="instruction-text">
              An empowered customer knows what product features are suited to
              his/her needs and conditions and can compare and product features
              among 2-4 Financial Service Providers (FSPs) actively operating in
              the area.
            </p>
            <p className="instruction-text">
              In this section, exercises are provided to refresh the customer
              about different types of FSPs and the product features to consider
              per selected financial product. A tool called Financial Product
              Matrix (FPM) is made available to help organize product
              information that will facilitate comparison and ranking between
              FSPs based on the customer’s specific preferences.
            </p>
          </Box>
        </Grid>
        <Grid Item xs={12} md={9} className="right-card">
          <Box className="fpm__card">
            <Box className="fpm--opening--text1" sx={{ textAlign: "center" }}>
              <p>
                Compare and Rank Product Features Among Financial Service
                Providers (FSP)
              </p>
            </Box>
            <Box className="child-card">
              <p>
                This time, we'll rank all of product terms based on their best
                fit to your needs The higher the number, the better the product
                terms for you. After ranking all FSP between product terms, you
                can now proceed to the last page
              </p>
              <Box className="scrollable-table">
                <TableContainer className="fpm---table---container">
                  <Table size="small" className="fpm---table">
                    <TableHead>
                      <TableRow className="fpm---table---header2">
                        <TableCell
                          className="fpm---table---cell2"
                          align="center"
                        >
                          {fspType}
                        </TableCell>
                        <TableCell
                          className="fpm---table---cell2"
                          align="center"
                          colSpan="100%"
                        >
                          Financial Service Provider (FSP)
                        </TableCell>
                      </TableRow>
                      <TableRow className="fpm---table---header">
                        <TableCell
                          className="fpm---table---cell2"
                          align="center"
                        >
                          Product Terms
                        </TableCell>
                        {q3Check1 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Bank
                          </TableCell>
                        ) : null}
                        {q3Check2 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Cooperatives
                          </TableCell>
                        ) : null}
                        {q3Check3 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Microfinance NGOs
                          </TableCell>
                        ) : null}
                        {q3Check4 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Lending and Finance Companies
                          </TableCell>
                        ) : null}
                        {q3Check5 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Insurance Companies
                          </TableCell>
                        ) : null}
                        {q3Check7 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Mutual Benefit Associations
                          </TableCell>
                        ) : null}
                        {q3Check6 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Digital FPS
                          </TableCell>
                        ) : null}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {myArray.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell className="fpm---table---cell1">
                            {row}
                          </TableCell>
                          {q3Check1 === true ? (
                            <TableCell className="fpm---table---cell">
                              <Grid container>
                                <Grid item xs={6}>
                                  <Box>
                                    <TextField
                                      defaultValue={bnkState[index]}
                                      sx={{ width: "15rem" }}
                                      variant="standard"
                                      InputProps={{
                                        disableUnderline: true,
                                        readOnly: true,
                                      }}
                                    />
                                  </Box>
                                </Grid>

                                <Grid item xs={6}>
                                  <Box>
                                    <Select
                                      size="small"
                                      native
                                      defaultValue="0"
                                      className="fpm---table---select"
                                      sx={{
                                        boxShadow: "none",
                                        ".MuiOutlinedInput-notchedOutline": {
                                          border: 0,
                                        },
                                      }}
                                      onChange={(e) =>
                                        handleSelectBnk(e, index)
                                      }
                                    >
                                      <option value={0}>0</option>
                                      {myArray2.map((options) => (
                                        <option key={options} value={options}>
                                          {options}
                                        </option>
                                      ))}
                                    </Select>
                                  </Box>
                                </Grid>
                              </Grid>
                            </TableCell>
                          ) : null}
                          {q3Check2 === true ? (
                            <TableCell className="fpm---table---cell">
                              <Grid container>
                                <Grid item xs={6}>
                                  <TextField
                                    defaultValue={coopState[index]}
                                    sx={{ width: "15rem" }}
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={6}>
                                  <Select
                                    size="small"
                                    native
                                    defaultValue="0"
                                    className="fpm---table---select"
                                    sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: 0,
                                      },
                                    }}
                                    onChange={(e) => handleSelectCoop(e, index)}
                                  >
                                    <option value="0">0</option>
                                    {myArray2.map((options) => (
                                      <option key={options} value={options}>
                                        {options}
                                      </option>
                                    ))}
                                  </Select>
                                </Grid>
                              </Grid>
                            </TableCell>
                          ) : null}
                          {q3Check3 === true ? (
                            <TableCell className="fpm---table---cell">
                              <Grid container>
                                <Grid item xs={6}>
                                  <TextField
                                    defaultValue={microState[index]}
                                    sx={{ width: "15rem" }}
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={6}>
                                  <Select
                                    size="small"
                                    native
                                    defaultValue="0"
                                    className="fpm---table---select"
                                    sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: 0,
                                      },
                                    }}
                                    onChange={(e) =>
                                      handleSelectMicro(e, index)
                                    }
                                  >
                                    <option value="0">0</option>
                                    {myArray2.map((options) => (
                                      <option key={options} value={options}>
                                        {options}
                                      </option>
                                    ))}
                                  </Select>
                                </Grid>
                              </Grid>
                            </TableCell>
                          ) : null}
                          {q3Check4 === true ? (
                            <TableCell className="fpm---table---cell">
                              <Grid container>
                                <Grid item xs={6}>
                                  <TextField
                                    defaultValue={lfState[index]}
                                    sx={{ width: "15rem" }}
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={6}>
                                  <Select
                                    size="small"
                                    native
                                    defaultValue="0"
                                    className="fpm---table---select"
                                    sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: 0,
                                      },
                                    }}
                                    onChange={(e) => handleSelectLF(e, index)}
                                  >
                                    <option value="0">0</option>
                                    {myArray2.map((options) => (
                                      <option key={options} value={options}>
                                        {options}
                                      </option>
                                    ))}
                                  </Select>
                                </Grid>
                              </Grid>
                            </TableCell>
                          ) : null}
                          {q3Check5 === true ? (
                            <TableCell className="fpm---table---cell">
                              <Grid container>
                                <Grid item xs={6}>
                                  <TextField
                                    defaultValue={imState[index]}
                                    sx={{ width: "15rem" }}
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={6}>
                                  <Select
                                    size="small"
                                    native
                                    defaultValue="0"
                                    className="fpm---table---select"
                                    sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: 0,
                                      },
                                    }}
                                    onChange={(e) => handleSelectIM(e, index)}
                                  >
                                    <option value="0">0</option>
                                    {myArray2.map((options) => (
                                      <option key={options} value={options}>
                                        {options}
                                      </option>
                                    ))}
                                  </Select>
                                </Grid>
                              </Grid>
                            </TableCell>
                          ) : null}
                          {q3Check7 === true ? (
                            <TableCell className="fpm---table---cell">
                              <Grid container>
                                <Grid item xs={6}>
                                  <TextField
                                    defaultValue={maState[index]}
                                    sx={{ width: "15rem" }}
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={6}>
                                  <Select
                                    size="small"
                                    native
                                    defaultValue="0"
                                    className="fpm---table---select"
                                    sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: 0,
                                      },
                                    }}
                                    onChange={(e) => handleSelectMA(e, index)}
                                  >
                                    <option value="0">0</option>
                                    {myArray2.map((options) => (
                                      <option key={options} value={options}>
                                        {options}
                                      </option>
                                    ))}
                                  </Select>
                                </Grid>
                              </Grid>
                            </TableCell>
                          ) : null}
                          {q3Check6 === true ? (
                            <TableCell className="fpm---table---cell">
                              <Grid container>
                                <Grid item xs={6}>
                                  <TextField
                                    defaultValue={digiState[index]}
                                    sx={{ width: "15rem" }}
                                    variant="standard"
                                    InputProps={{
                                      disableUnderline: true,
                                      readOnly: true,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={6}>
                                  <Select
                                    size="small"
                                    native
                                    defaultValue="0"
                                    className="fpm---table---select"
                                    sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: 0,
                                      },
                                    }}
                                    onChange={(e) => handleSelectDigi(e, index)}
                                  >
                                    <option value="0">0</option>
                                    {myArray2.map((options) => (
                                      <option key={options} value={options}>
                                        {options}
                                      </option>
                                    ))}
                                  </Select>
                                </Grid>
                              </Grid>
                            </TableCell>
                          ) : null}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            <Box>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <p className="link-text" onClick={() => handleOpenSample()}>
                    See Sample FPM Table with scores
                  </p>
                </Grid>
                <Grid item xs={12} md={6} className="left-card">
                  <Box
                    className="fpm__button__container"
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      className="fpm--button-2"
                      onClick={() => handleBack()}
                    >
                      Back
                    </Button>
                    <Button
                      className="fpm--button"
                      onClick={() => handleContinue()}
                      sx={{ width: "50%" }}
                    >
                      Next
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Modal open={openSample} onClose={handleCloseSample}>
        <Box className="fpm__modal2">
          <Box className="fpm--modal--text">
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <CloseRounded
                className="fpm--modal--iconButton"
                onClick={() => handleCloseSample()}
              />
            </Box>
            <Box className="table-img-container">
              <img
                src={tableGuide}
                alt="Table"
                style={{ width: "100%", objectFit: "cover" }}
              />
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default FpmPage4;
